
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.268 12.67h-.838l-.297-.287a6.893 6.893 0 001.57-5.665c-.498-2.949-2.96-5.304-5.933-5.664a6.902 6.902 0 00-7.716 7.712c.36 2.97 2.717 5.431 5.668 5.93a6.903 6.903 0 005.668-1.57l.286.297v.838l4.511 4.508a1.122 1.122 0 001.582 0 1.12 1.12 0 000-1.58l-4.5-4.52zm-6.368 0a4.769 4.769 0 01-4.776-4.774A4.769 4.769 0 017.9 3.122a4.769 4.769 0 014.776 4.774A4.769 4.769 0 017.9 12.669z","fill":"#000"}})])
          )
        }
      }
    